"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = exports.CheckboxRoot = exports.CheckboxIndicator = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var Checkbox = _interopRequireWildcard(require("@radix-ui/react-checkbox"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Container = exports.Container = _styledComponents["default"].label.withConfig({
  displayName: "Checkboxstyle__Container",
  componentId: "sc-qtse00-0"
})({
  position: 'relative',
  display: 'inline-block',
  cursor: 'pointer',
  fontSize: 0,
  verticalAlign: 'middle'
});
var CheckboxRoot = exports.CheckboxRoot = (0, _styledComponents["default"])(Checkbox.Root).withConfig({
  displayName: "Checkboxstyle__CheckboxRoot",
  componentId: "sc-qtse00-1"
})(function (_ref) {
  var color = _ref.theme.color;
  return {
    backgroundColor: 'transparent',
    cursor: 'pointer',
    display: 'inline-block',
    border: "2px solid ".concat(color.neutral['04']),
    borderRadius: 3,
    width: 18,
    height: 18,
    boxSizing: 'border-box',
    color: color.neutral['08'],
    '&:hover, label:hover &': {
      borderColor: color.brandPrimary.light
    },
    '[data-state="checked"]': {
      backgroundColor: color.brandPrimary.light,
      border: color.brandPrimary.light,
      display: 'inline-block',
      cursor: 'pointer',
      borderRadius: 3,
      width: 18,
      height: 18,
      boxSizing: 'border-box',
      color: color.neutral['08']
    },
    '&:disabled': {
      background: color.line.medium,
      borderColor: color.neutral['04'],
      cursor: 'default',
      '[data-state="checked"]': {
        background: color.neutral['04'],
        width: '100%',
        height: '100%'
      }
    }
  };
});
var CheckboxIndicator = exports.CheckboxIndicator = (0, _styledComponents["default"])(Checkbox.Indicator).withConfig({
  displayName: "Checkboxstyle__CheckboxIndicator",
  componentId: "sc-qtse00-2"
})(function () {
  return {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 1,
    svg: {
      position: 'absolute',
      top: 1,
      bottom: 0,
      right: 0,
      left: 1,
      width: '1rem'
    }
  };
});